import React from "react";
import { Popover, PopoverProps } from "@mui/material";
import { styled } from "@mui/material/styles";

interface CustomPopoverProps extends PopoverProps {
  customStyles?: React.CSSProperties;
}

const Wrapper = styled(Popover)<{ customStyles?: React.CSSProperties }>(
  ({ customStyles }) => ({
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0)",
    },
    "& .MuiPaper-root": {
      backgroundColor: "var(--secondary-bg)",
      boxShadow: "var(--popover-box-shadow)",
      borderRadius: "25px",
      maxWidth: "100%",
      ...customStyles,
    },
  }),
);

export default function PopoverContainer({
  children,
  customStyles,
  ...rest
}: CustomPopoverProps) {
  return (
    <Wrapper
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      customStyles={customStyles}
      {...rest}
    >
      {children}
    </Wrapper>
  );
}
